module.exports = __webpack_public_path__ + "static/laurie-e8b96a4ecf99cd00da160e0b4e4e223f.png";